export enum featuresByDefault {
  DESKTOP = 4,
  TABLET = 5,
}
